import { Chip, Stack, Typography, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { AbsColor } from '../../constants';
import { RegulationAction, RegulationFetch } from '../../features/regulation.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';
import RegulationCards from '../regulation/regulation-cards.component';
import { Loading } from '../shared';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { IRegulation } from '../../contracts/amendment.contract';
import { VesselAction } from '../../features/vessel.feature';
import regulationFilterText from '../shared/regulation-filter-text';
import { sortRegulationsByAdoptionDate } from '../shared/adoption-date-sort.util';

const VesselFilters = () => {
    const dispatch = useAppDispatch();
    const vessels = useAppSelector((state) => state.Vessel.List.Vessels);
    const classNumbers = useAppSelector((state) => state.Regulation.ByVessel.Filters.ClassNumbers);

    const handleDelete = (item: string) => {
        if (!item) return;
        dispatch(RegulationAction.ByVesselRemoveFilterClassNumber(item));
    };

    const getLabel = (classNumber: string): string => {
        const vessel = vessels?.find((f) => f.ClassNumber === classNumber);
        return vessel?.VesselName || classNumber;
    };

    return (
        <div style={{ width: '100%' }}>
            {classNumbers && classNumbers.length > 0 ? (
                <>
                    <Typography variant={'h6'}>
                        {`${classNumbers.length}`}
                        {`${classNumbers.length === 1 ? ' Vessel' : ' Vessels'} Selected `}:
                    </Typography>
                    {classNumbers.map((item: string) => {
                        return <Chip key={item} label={getLabel(item)} onDelete={() => handleDelete(item)} style={{ gap: 10, marginRight: 5, marginBottom: 5 }} />;
                    })}
                </>
            ) : (
                <>{/* No Filters */}</>
            )}
        </div>
    );
};

const VesselCriteriaResults = () => {
    const dispatch = useAppDispatch();
    const vessels = useAppSelector((state) => state.Vessel.List.Vessels);
    const regulations = useAppSelector((state) => state.Regulation.ByVessel.Regulations);
    const filters = useAppSelector((state) => state.Regulation.ByVessel.Filters.ClassNumbers);

    const isLoadingVessel = useAppSelector((state) => state.Vessel.List.IsLoading);
    const isLoadingRegulation = useAppSelector((state) => state.Regulation.ByVessel.IsLoading);
    const isLoading = isLoadingVessel || isLoadingRegulation;

    const [searchQuery, setSearchQuery] = useState<string>('');
    const [filteredRegulations, setFilteredRegulations] = useState<IRegulation[]>([]);

    useEffect(() => {
        let classNumbers: string[] = [];

        // Use selected vessels if available
        if (filters && filters.length > 0) classNumbers = filters;
        else classNumbers = vessels?.map((f) => f.ClassNumber) ?? [];

        // Clear existing regulations in redux store
        // Need revisiting in future

        dispatch(RegulationAction.CancelApiRequests());
        dispatch(RegulationAction.ClearByVesselRegulations());

        // Fetch regulations in chunks of 5 to avoid overloading the API
        const chunkSize = 5;
        for (let i = 0; i < classNumbers.length; i += chunkSize) {
            const chunk = classNumbers.slice(i, i + chunkSize);
            dispatch(RegulationFetch.GetByVesselClassNumbers(chunk));
        }
    }, [vessels, filters, dispatch]);

    useEffect(() => {
        if (!regulations) return;

        const filtered = regulationFilterText(searchQuery, regulations);
        setFilteredRegulations(sortRegulationsByAdoptionDate(filtered));
    }, [searchQuery, regulations]);

    const handleClearSearch = () => {
        setSearchQuery('');
        dispatch(VesselAction.SetUserSearchQuery({ UserSearchQuery: '' }));
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        dispatch(VesselAction.SetUserSearchQuery({ UserSearchQuery: e.target.value }));
    };

    return (
        <>
            <Stack direction="column" alignItems="center">
                {/* {vessels && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <TextField
                            variant="outlined"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ width: '100%' }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleClearSearch}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            size="small"
                        />
                    </div>
                )} */}

                <VesselFilters />
                {isLoading ? (
                    <Loading />
                ) : (
                    <>
                        {filteredRegulations.length > 0 ? (
                            <RegulationCards regulations={filteredRegulations} />
                        ) : (
                            <Typography variant="h6" color={AbsColor.Blue1}>
                                No results found.
                            </Typography>
                        )}
                    </>
                )}
            </Stack>
        </>
    );
};

export default VesselCriteriaResults;
